define([
	"dojo/_base/declare",
	"csi",
	"csi/form/Widget",
	"csi/html",
	"csi/xml"
], function(declare,csi,Widget,html,xml) {

	return declare(Widget, {
		_valueType: null,

		_buildView: function() {
			// summary: store current type value to support onChange behavior
			var	node = this.getViewNode();
			this._valueType = node ? node.MaterialType : null;
			this.inherited(arguments); 
		},

		onChangeType: function(/*csi.def.View*/defView, /*csi.def.Field*/field, /*Any*/value) {
			// summary: initialize name from type
			var	fName = this.defView.getField(xml.ATTR_NAME);
			var	store = field.m_control.store;
			var	type = store.get(value);

			if (type && fName) {
				var	oldName = fName.getValue();
				var	oldType = this._valueType ? store.get(this._valueType) : null;
				var	oldTypeName = oldType ? oldType[store.labelProperty] : "";
				var	newName = type[store.labelProperty];

				if (!oldName || (oldName == oldTypeName)) {
					this.setFieldValue(fName, newName);
				}
			}

			this._valueType = value;
		}
	});
});